import { IVUE_APP_ENV } from '@/interface'

const envRedPackContractAddress = {
  devnet: {
    // Polygon testnet
    80001: '0xb1efb300876f993Dc6826f09E66FEaa1bc3A735F',
    // BSC testnet
    97: '0xF1C4464FA07D61B6f65D4da885936C62ccDb8189',
    // FX EVM devnet
    221: '0x8446754cE8720871f598FA5f7685D55Fa5973788'
  },
  testnet: {
    // Polygon testnet
    80001: '0xb1efb300876f993Dc6826f09E66FEaa1bc3A735F',
    // BSC testnet
    97: '0xF1C4464FA07D61B6f65D4da885936C62ccDb8189',
    // FX EVM testnet
    90001: '0xeF0FD8Fc035C303AA571559f509c5E1778Ca12c3'
  },
  prod: {
    // Polygon mainnet
    137: '0x3363994E2f338F05b391e6e0404D5212c4400b57',
    // BSC mainnet
    56: '0xf42869CB7BFa9e77589C1D8Cd1D30E1cC0A9963A'
    // FX EVM mainnet
  }
} as {
  [key in IVUE_APP_ENV]: {
    [key: number]: string
  }
}

export default envRedPackContractAddress[process.env.VUE_APP_ENV as IVUE_APP_ENV]
